"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterPlansByStaleness = filterPlansByStaleness;
exports.filterPlansByTargetVersion = filterPlansByTargetVersion;
exports.filterPlansWithBlockedSteps = filterPlansWithBlockedSteps;
const planUtils_1 = require("../planUtils");
/**
 * Filters an array of plans by their staleness flag.
 *
 * @param plans - The array of plans to filter.
 * @param staled - If true, returns only stale plans; if false, returns only non‑stale plans.
 * @returns A new array containing only plans matching the staleness criteria.
 */
function filterPlansByStaleness(plans, staled) {
    return plans.filter(p => (p.staled ?? false) === staled);
}
/**
 * Filters an array of plans by their target release version.
 *
 * @param plans - The array of plans to filter.
 * @param version - The target version string to match exactly.
 * @returns A new array containing only plans with the given target version.
 */
function filterPlansByTargetVersion(plans, version) {
    return plans.filter(p => p.target_version === version);
}
/**
 * Filters an array of plans to only those that contain at least one genuinely blocked step.
 *
 * @param plans - The array of plans to filter.
 * @param index - The link index for resolving blockers.
 * @returns A new array containing only plans that have one or more blocked steps.
 */
function filterPlansWithBlockedSteps(plans, index) {
    return plans.filter(p => {
        if (!p.steps)
            return false;
        return p.steps.some(s => s.status !== 'done' && s.status !== 'cancelled' && (0, planUtils_1.isStepBlocked)(s, p, index));
    });
}
